import { createContext, useContext } from "react";

export interface FullScreenModalContextValue {
  requestClose: () => void;
  /** 모달 루트 내부 폼 필드 포커스 시 true */
  isInputFocused: boolean;
}

export const FullScreenModalContext =
  createContext<FullScreenModalContextValue | null>(null);

export const useFullScreenModal = () => {
  const ctx = useContext(FullScreenModalContext);
  if (!ctx) {
    throw new Error(
      "useFullScreenModal은 FullScreenModal 내부에서만 사용하세요.",
    );
  }
  return ctx;
};
